<template>
  <div class="pt-3 px-3">
    <v-layout>
      <v-flex
        xs12
        md5
        xl5>
        <v-btn
          class="mb-4"
          @click="$router.push({ path: `/admin/master-payer-report/`})"
        ><v-icon
          color="primary"
          class="mr-2">arrow_back</v-icon> Go back to Attestation Report</v-btn>
      </v-flex>
      <Can
        I="manage"
        a="reports">
        <v-flex style="text-align: right">
          <HelperCsvDownload
            :data="filteredAccounts"
            :getData="getFilteredAccounts"
            :title="'Masterpayer-report'"
            @csv-download-success="downloadFinished"/>
        </v-flex>
      </Can>
    </v-layout>
    <material-card
      :title="masterPayerReportListTitle"
      :text="masterPayerReportListText"
      color="orange">
      <v-layout
        class="account-filters"
        justify-center
        wrap>
        <v-flex md2>
          <v-text-field
            v-model="search"
            label="Search"
            single-line
            hide-details
            append-icon="search"
          />
        </v-flex>
      </v-layout>
      <v-data-table
        ref="accountList"
        :headers="getAccountHeaders"
        :items="filteredAccounts"
        :search="search"
        :pagination.sync="pagination"
        v-model="selected"
        class="accounts-table"
        loading
        loading-text="Loading... Please wait"
        item-key="Acct_ID"
      >
        <template
          slot="headerCell"
          slot-scope="{ header }">
          <span
            class="subheading font-weight-light text-success text-md-left text--darken-3"
            v-text="header.text"
          />
        </template>
        <template v-slot:items="props">
          <tr>
            <td>{{ props.item.Acct_name }}</td>
            <td>{{ props.item.OppReg_Id }}</td>
            <td>{{ props.item.Acct_Status }}</td>
            <td>{{ props.item.Acct_Offering_Stat }}</td>
            <td>{{ props.item.Acct_DL }}</td>
            <td>{{ props.item.Acct_ID }}</td>
            <td>{{ props.item.Date_onboarded }}</td>
            <td>{{ props.item.Last_Date_Validated }}</td>
            <td>{{ props.item.Date_Suspended }}</td>
            <td>{{ props.item.MP_ID }}</td>
            <td>
              <div v-if="props.item.DateMarkedAsUnknown !== 'None' && props.item.MP_Name.includes('UNKNOWN')">
                <v-chip
                  color="orange"
                  text-color="white">
                  <span v-html="daysMarkedAsUnknown(props.item.DateMarkedAsUnknown)"/>
                </v-chip>
              </div>
              <div v-else>
                None
              </div>
            </td>
            <td>{{ props.item.Previous_MP_ID }}</td>
            <td>{{ props.item.Customer_Name }}</td>
            <td>{{ props.item.Customer_Alias_Group }}</td>
            <td>{{ props.item.Managed_Svc }}</td>
            <td>{{ props.item.AWS_Support_Type }}</td>
            <td>{{ props.item.Customer_Region }}</td>
            <td>{{ props.item.Acct_Restricted }}</td>
            <td>{{ props.item.MFA }}</td>
            <td>{{ props.item.Root_Credential_Store }}</td>
            <td>{{ props.item.DXC_discount }}</td>
            <td>{{ props.item.Client_discount }}</td>
            <td>{{ props.item.MP_uplift }}</td>
            <td>{{ props.item.Client_uplift }}</td>
            <td>{{ props.item.WBS_code }}</td>
            <td>{{ props.item.IWO_Code }}</td>
            <td>{{ props.item.Comments }}</td>
          </tr>
        </template>
      </v-data-table>

    </material-card>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  data: () => ({
    selected: [],
    selectedAcctStatus: ['New', 'ACTIVE'],
    menu2: false,
    search: '',
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0
    },
    agreementFilter: 'all',
    archivedAcctStatus: null,
    groupAliasFilter: [],
    titlesMap: {
      new_accounts: 'New Accounts',
      current_active: 'Current Active Accounts',
      suspended: 'Suspended Accounts',
      active_accounts_left: 'Number of Accounts left the Org(active)',
      suspended_accounts_left: 'Number of Accounts left the Org(suspended) > 90 days',
      last_qtr_active: 'Last Quarter End Active',
      // reported_count: 'Reported Count'
    },
    quarters: [
      {
        text: `First Quarter (Dec 1 ${new Date().getFullYear() - 1}-Feb 28 ${new Date().getFullYear()})`,
        value: 0,
        columnLabel: '(Dec 1-Feb 28)',
        fromDate: `${new Date().getFullYear() - 1}-12-01`,
        toDate: `${new Date().getFullYear()}-02-28`,
        toText: `Feb 28 ${new Date().getFullYear()}`
      },
      {
        text: `Second Quarter (Mar 1 ${new Date().getFullYear()}-May 31 ${new Date().getFullYear()})`,
        value: 1,
        columnLabel: '(Mar 1-May 31)',
        fromDate: `${new Date().getFullYear()}-03-01`,
        toDate: `${new Date().getFullYear()}-05-31`,
        toText: `May 31 ${new Date().getFullYear()}`
      },
      {
        text: `Third Quarter (Jun 1 ${new Date().getFullYear()}-Aug 31 ${new Date().getFullYear()})`,
        value: 2,
        columnLabel: '(Jun 1-Aug 31)',
        fromDate: `${new Date().getFullYear()}-06-01`,
        toDate: `${new Date().getFullYear()}-08-31`,
        toText: `Aug 31 ${new Date().getFullYear()}`
      },
      {
        text: `Fourth Quarter (Sep 1 ${new Date().getFullYear()}-Nov 30 ${new Date().getFullYear()})`,
        value: 3,
        columnLabel: '(Sep 1-Nov 30)',
        fromDate: `${new Date().getFullYear()}-09-01`,
        toDate: `${new Date().getFullYear()}-11-30`,
        toText: `Nov 30 ${new Date().getFullYear()}`
      }
    ]
  }),
  computed: {
    ...mapState('admin/accountInventory', ['masterAccounts']),
    ...mapGetters({
      getAccountHeaders: 'admin/accountInventory/getAccountHeadersByMP'
    }),
    masterPayerReportListTitle () {
      return this.titlesMap[this.$route.params.status]
    },
    masterPayerReportListText () {
      switch (this.$route.params.status) {
        case 'new_accounts':
        case 'suspended':
        case 'active_accounts_left':
        // case 'reported_count':
        //   return this.quarters[this.$route.query.quarter].text
        case 'current_active':
          return this.quarters[this.$route.query.quarter].text
        case 'suspended_accounts_left':
          return 'Suspended > 90 days'
        case 'last_qtr_active':
          if (this.$route.query.quarter == 0 ) {
            return `Fourth Quarter (Sep 1 ${new Date().getFullYear() - 1}-Nov 30 ${new Date().getFullYear() - 1})`
          } else {
            return this.quarters[this.$route.query.quarter - 1].text
          }
        default:
          return ''
      }
    },
    currentQuarter () {
      // get current Date
      let currentDate = window.moment(new Date())
      let currentQuarter = null
      for (const qtr in this.quarters) {
        if (this.quarters.hasOwnProperty(qtr)) {
          if (window.moment(this.quarters[qtr].fromDate) <= currentDate && window.moment(this.quarters[qtr].toDate) >= currentDate) {
            currentQuarter = qtr
          }
        }
      }
      return currentQuarter
    },
    filteredAccounts () {

      let firstQuarter = null
      if (this.$route.query.quarter == 0) {
        let currentMonth = new Date().getMonth()
        // if current Month is December
        if (currentMonth === 11) {
          firstQuarter = {
            fromDate: `${new Date().getFullYear()}-09-01`,
            toDate: `${new Date().getFullYear()}-11-30`
          }
        } else {
          firstQuarter = {
            fromDate: `${new Date().getFullYear() - 1}-09-01`,
            toDate: `${new Date().getFullYear() - 1}-11-30`
          }
        }
      }

      let accountsByStatus = []

      switch (this.$route.params.status) {
        case 'new_accounts':
          accountsByStatus = this.masterAccounts.filter(account => window.moment(account.Date_onboarded) > window.moment(this.quarters[this.$route.query.quarter].fromDate) && window.moment(account.Date_onboarded) < window.moment(this.quarters[this.$route.query.quarter].toDate) && account.Acct_Status === 'ACTIVE')
          break
        case 'current_active':
          // if (firstQuarter) {
          //   accountsByStatus = this.masterAccounts.filter(account => window.moment(account.Date_onboarded) > window.moment(firstQuarter.fromDate) && window.moment(account.Date_onboarded) < window.moment(this.quarters[this.$route.query.quarter].toDate) && account.Acct_Status === 'ACTIVE')
          // } else {
          //   accountsByStatus = this.masterAccounts.filter(account => window.moment(account.Date_onboarded) > window.moment(this.quarters[this.$route.query.quarter - 1].fromDate) && window.moment(account.Date_onboarded) < window.moment(this.quarters[this.$route.query.quarter].toDate) && account.Acct_Status === 'ACTIVE')
          // }

          accountsByStatus = this.masterAccounts.filter(account => window.moment(account.Date_onboarded) < window.moment(this.quarters[this.$route.query.quarter].toDate) && account.Acct_Status === 'ACTIVE')
          break
        case 'suspended':
          accountsByStatus = this.masterAccounts.filter(account => window.moment(account.Date_onboarded) > window.moment(this.quarters[this.$route.query.quarter].fromDate) && window.moment(account.Date_onboarded) < window.moment(this.quarters[this.$route.query.quarter].toDate) && account.Acct_Status === 'SUSPENDED')
          break
        case 'active_accounts_left':
          accountsByStatus = this.masterAccounts.filter(account => window.moment(account.Last_Date_Validated) > window.moment(this.quarters[this.$route.query.quarter].fromDate) && window.moment(account.Last_Date_Validated) < window.moment(this.quarters[this.$route.query.quarter].toDate) && (account.Acct_Status === 'Moved to Client' || account.Acct_Status === 'Moved to Masterpayer'))
          break
        case 'suspended_accounts_left':
          // let suspendedAccounts = this.masterAccounts.filter(account => window.moment(account.Date_onboarded) > window.moment(this.quarters[this.$route.query.quarter].fromDate) && window.moment(account.Date_onboarded) < window.moment(this.quarters[this.$route.query.quarter].toDate) && account.Acct_Status === 'SUSPENDED')
          accountsByStatus = this.masterAccounts.filter(account => {
            let dateSuspended = window.moment(account.Date_Suspended, 'YYYY-MM-DD')
            let lastDateValidated = window.moment(account.Last_Date_Validated, 'YYYY-MM-DD')
            let todaysDate = window.moment()
            return (window.moment.duration(todaysDate.diff(dateSuspended)).asDays() > 90 && account.Acct_Status === 'SUSPENDED' && account.Acct_Status !== 'None') || (window.moment.duration(todaysDate.diff(lastDateValidated)).asDays() > 90 && account.Acct_Status === 'SUSPENDED' && account.Acct_Status !== 'None')
          })
          break
        case 'last_qtr_active':
          // if select quarter is first
          if (firstQuarter) {
            accountsByStatus = this.masterAccounts.filter(account => window.moment(account.Date_onboarded) < window.moment(firstQuarter.toDate) && account.Acct_Status === 'ACTIVE')
          } else {
            accountsByStatus = this.masterAccounts.filter(account => window.moment(account.Date_onboarded) < window.moment(this.quarters[this.$route.query.quarter - 1].toDate) && account.Acct_Status === 'ACTIVE')
          }
          break
        // case 'reported_count':
        //   accountsByStatus = this.masterAccounts.filter(account => window.moment(account.Date_onboarded) > window.moment(this.quarters[this.$route.query.quarter].fromDate) && window.moment(account.Date_onboarded) < window.moment(this.quarters[this.$route.query.quarter].toDate) && (account.Acct_Status === 'ACTIVE' || account.Acct_Status === 'SUSPENDED'))
        //   break
        default:
          break
      }
      let accountsByMP
      // if (this.$route.query.mp === 'others') {
      //   accountsByMP = accountsByStatus.filter(account => !['ppa', 'sp', 'spp', 'legacy'].includes(account.agreement))
      if (this.$route.query.mp === 'spp') {
        accountsByMP = accountsByStatus.filter(account => account.agreement === 'spp' || account.agreement === 'edp - vale')
      } else {
        accountsByMP = accountsByStatus.filter(account => account.agreement === this.$route.query.mp)
      }
      return accountsByMP
    }
  },
  methods: {
    getFilteredAccounts () {
      this.pagination.rowsPerPage = -1
      let data = this.$refs.accountList.filteredItems
      this.pagination.rowsPerPage = 10
      return data
    },
    downloadFinished () {
      console.log('download finished')
      this.pagination.rowsPerPage = 10
    },
    daysMarkedAsUnknown (item) {
      let currentDate = new Date()
      let markedDate = new Date(item)
      let cDate = currentDate.valueOf()
      let mDate = markedDate.valueOf()

      let since_days = (cDate - mDate) / 1000 / 86400
      since_days = Math.round(since_days - 0.5)
      return since_days + (since_days > 1 ? ' Days ago.' : ' Day ago.')
    }
  }
}
</script>
<style lang="scss" scoped>
table.v-table thead th:first-child {
  font-size: 10px;
}

.masterDropdown {
  margin-bottom: 0;
  .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
    background: linear-gradient(60deg, #ffa726, #fb8c00) !important;
    color: #fff !important;
  }
  .theme--light.v-select .v-select__selections {
    color: #fff !important;
  }
  .theme--light.v-icon {
    color: #fff;
  }
}
.v-progress-linear {
      margin: 0;
      bottom: -15px;
  }

</style>
